import { render, staticRenderFns } from "./management-settings.vue?vue&type=template&id=0540c0ac&scoped=true"
import script from "./management-settings.vue?vue&type=script&lang=js"
export * from "./management-settings.vue?vue&type=script&lang=js"
import style0 from "./management-settings.vue?vue&type=style&index=0&id=0540c0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540c0ac",
  null
  
)

export default component.exports